module.exports = __webpack_public_path__ + "img/transaksi.854acc39.jpg";